"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCENARIO_PERIOD_ALL = 'all';